<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <template v-if="listeRegionsSupervisees.length == 0">
          <div>
            <v-btn @click="$router.push('/')" rounded color="success"
              ><v-icon left>mdi-reload</v-icon> recharger
            </v-btn>
          </div>
        </template>
        <template v-else>
          <v-card flat>
            <v-card-title primary-title>
              Bienvenue {{ user.displayName }}
            </v-card-title>
            <v-card-text>
              <v-list dense>
                <v-subheader>Régions supervisées</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item v-for="(item, i) in regions" :key="i">
                    <v-list-item-icon>
                      <v-icon large color="green darken-2">
                        mdi-map
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.ll_region"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text>
              <v-list dense>
                <v-subheader>Projets</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item v-for="(item, i) in user.projets" :key="i">
                    <v-list-item-icon>
                      <v-icon large color="green darken-2">
                        mdi-arrow-right-drop-circle
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.ll_programme"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </template>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      regions: [],
    };
  },
  created() {
    this.GetActivites();
    this.GetAllTypeDetails();
    this.GetAllRolesHorsGroupe();
    this.getBailleurs();
    this.getProjets();
    this.GetCampagnes();
    this.GetCampagneActive();
    //this.GetIdentifiantsAll();
    this.getAnimateurs(this.listeRegionsSupervisees);
    this.getDetailsRegionsSupervisees(this.listeRegionsSupervisees);
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      GetActivites: "Activites/GetAll",
      GetAllTypeDetails: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetCampagnes: "Campagnes/GetAll",
      GetIdentifiantsAll: "Users/getAll",
      getAnimateurs: "Users/getAnimateurs",
      GetCampagneActive: "Campagnes/GetCampagneActive",
    }),
    getDetailsRegionsSupervisees(regionSupervisees) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("id", "in", regionSupervisees)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.regions.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log(self.regions);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
      Activites: (state) => state.Activites.Activites,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
